import { render, staticRenderFns } from "./weMedia_list.vue?vue&type=template&id=36d0228c&scoped=true"
import script from "./weMedia_list.vue?vue&type=script&lang=js"
export * from "./weMedia_list.vue?vue&type=script&lang=js"
import style0 from "./weMedia_list.vue?vue&type=style&index=0&id=36d0228c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d0228c",
  null
  
)

export default component.exports